<script setup>

import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";
import {useStore} from "vuex";
import {computed} from "vue";

const store = useStore();

const view = computed(() => store.getters['competitionV2/comparisonType']);

</script>

<template>
  <SelectInput
    :value="view"
    @input="(e) => store.dispatch('competitionV2/setComparisonType', e.target.value)"
  >
    <template #icon>
      <svg-vue
        icon="icons/keyword-target"
        class="tw-w-7 tw-h-7 tw-my-2 tw-ml-3 tw-text-grey"
      />
    </template>
    <template #default>
      <option value="keyword">
        Keyword Comparison
      </option>
      <option value="backlink">
        Backlink Comparison
      </option>
    </template>
  </SelectInput>
</template>
